import { itemContext, sectionContext, pageContext } from 'context'
import { Item } from 'schema'
import { isAfter } from 'date-fns' 
import _ from 'lodash'

class Page {
    constructor(props){
        // Original //
        // let updatedProps = props || {}
        // this.pageID = updatedProps.pageID || '';
        // this.page_name = updatedProps.page_name;
        // this.create_date = updatedProps.create_date || new Date().toString().slice(0,24);
        // this.page_view = updatedProps.page_view || pageContext.VIEWS.LIST_VIEW;
        // this.favourite = updatedProps.favourite || false;
        // this.full_width = updatedProps.full_width || false;
        // this.item_divider = updatedProps.item_divider || true;
        // this.show_completed = updatedProps.show_completed || false;
        // this.page_sections = updatedProps.page_sections || [];
        // this.status = updatedProps.status || pageContext.STATUS.ACTIVE;
        // this.icon = updatedProps.icon || '';
        // this.tags = updatedProps.tags || [];
        // this.sections = updatedProps.sections || {};
        // this.createdBy = updatedProps.createdBy || '';
        // this.priorityLevels = {'HIGH': 3, 'MEDIUM': 2, 'LOW':1, 'None':0};

        let updatedProps = props || {}
        this._id = updatedProps.pageID || updatedProps['_id'];
        this.pageID = updatedProps.pageID || updatedProps['_id'];
        this.page_name = updatedProps.page_name;
        this.create_date = updatedProps.create_date || new Date().toString().slice(0,24);
        this.updatedBy = updatedProps.updatedBy;
        
        this.page_view = updatedProps.page_view || pageContext.VIEWS.LIST_VIEW;
        this.favourite = updatedProps.favourite || false;
        this.full_width = updatedProps.full_width || false;
        this.item_divider = updatedProps.item_divider !== undefined ? updatedProps.item_divider : true;
        this.show_completed = updatedProps.show_completed || false;
        this.sections = updatedProps.sections || [];
        this.status = updatedProps.status || pageContext.STATUS.ACTIVE;
        this.icon = updatedProps.icon;
        this.tags = updatedProps.tags || {};
        this.createdBy = updatedProps.createdBy;
        this.sharedWith = updatedProps.sharedWith || [];
        this.notes = updatedProps.notes

        this.sort = updatedProps.sort
        this.group = updatedProps.group
        this.filters = updatedProps.filters
    }

    

    pageTopItemsHandler(itemID, itemNode, topPriorityItems, upcomingItems, placeholderItems){
        const today = new Date(new Date().setHours(0,0,0,0))
        // Placeholder items
        if(placeholderItems.length < 2){
            placeholderItems.push({itemID: itemID, itemNode:itemNode})
        }
    
        // Check for dates
        const start_date = itemNode.item_details.start_date ? itemNode.item_details.start_date : null;
        const end_date = itemNode.item_details.end_date ? itemNode.item_details.end_date : null;
        const s = new Date(start_date) - new Date();
        const e = new Date(end_date) - new Date();
        const min_date = (s > 0 && e < 0) || (e > 0 && s > 0 && s < e) ? start_date 
                        : (e > 0 && s < 0) || (e > 0 && s > 0 && e < s) ? end_date
                        : null
    
        let upcoming_dates = [];
        if(upcomingItems.length > 0){
            upcomingItems.map(upcomingItem => {
                const us = new Date(upcomingItem.itemNode.item_details.start_date ? upcomingItem.itemNode.item_details.start_date : null) - new Date();
                const ue = new Date(upcomingItem.itemNode.item_details.end_date ? upcomingItem.itemNode.item_details.end_date : null) - new Date();
                if((us > 0 && ue < 0) || (us <= ue && us > 0 && ue > 0)){
                    upcoming_dates.push(upcomingItem.itemNode.item_details.start_date)
                } else if ((ue > 0 && us < 0) || (ue <= us && us > 0 && ue > 0)) {
                    upcoming_dates.push(upcomingItem.itemNode.item_details.end_date)
                } else{
                    
                }
            })
        }
    
        if(Object.keys(upcomingItems).length < 2 && (new Date(start_date) >= today || new Date(end_date) >= today)){
            upcomingItems.push({itemID: itemID, itemNode:itemNode})
        } else if (Object.keys(upcomingItems).length === 2 && (start_date || end_date)) {
            const upcoming_min_date = upcoming_dates[0] < upcoming_dates[1] ? upcoming_dates[1] : upcoming_dates[0];
            let a = new Date(min_date) - new Date();
            let b = new Date(upcoming_min_date) - new Date();
            if(a < b && a > 0 && b > 0){
                upcomingItems[upcoming_dates.indexOf(upcoming_min_date)] = {itemID: itemID, itemNode:itemNode}
            }
        }
    
        // Check for priority
        const priority = itemNode.item_details.priority;
        const ip = this.priorityLevels[priority];
    
        let priorities = [];
        if(topPriorityItems.length > 0){
            topPriorityItems.map(topPriorityItem => {
                const tp = this.priorityLevels[topPriorityItem.itemNode.item_details.priority]
                priorities.push(tp);
            })
        }
    
        if(Object.keys(topPriorityItems).length < 2 && ip > 0){
            topPriorityItems.push({itemID: itemID, itemNode:itemNode})
        } else if (Object.keys(topPriorityItems).length === 2 && ip > 0) {
            const min_priority = priorities[0] < priorities[1] ? priorities[0] : priorities[1];
            if(ip > min_priority){
                topPriorityItems[priorities.indexOf(min_priority)] = {itemID: itemID, itemNode:itemNode}
            }
        }
    
        if(itemNode.item_details.item_children){
            if(itemNode.item_details.item_children.INCOMPLETE){
                const children = Object.values(itemNode.item_details.item_children.INCOMPLETE);
                children.map(childID => {
                    this.pageTopItemsHandler(childID, itemNode.item_children[childID], topPriorityItems, upcomingItems, placeholderItems);
                })
            }
        }
    
        // Final sort
        if(topPriorityItems.length > 1){
            if(this.priorityLevels[Object.values(topPriorityItems)[1].itemNode.item_details.priority] > this.priorityLevels[Object.values(topPriorityItems)[0].itemNode.item_details.priority]){
                topPriorityItems = topPriorityItems.reverse();
            }
        }
    
        if(upcomingItems.length > 1){
            const a = Object.values(upcomingItems)[0].itemNode.item_details
            const a_start = new Date(a.start_date);
            const a_end = new Date(a.end_date);
            const min_a = a_start < a_end && a_start >= today ? a_start : a_end;
    
            const b = Object.values(upcomingItems)[1].itemNode.item_details
            const b_start = new Date(b.start_date);
            const b_end = new Date(b.end_date);
            const min_b = b_start < b_end && b_start >= today ? b_start : b_end
            
            if(min_b < min_a){
                upcomingItems = upcomingItems.reverse();
            }
        }
    }

    getPageStats(data){
        const incomplete = Object.values(data).filter(item => item['status'] === 'INCOMPLETE').length
        const completed = Object.values(data).filter(item => item['status'] === 'COMPLETED').length
        return {
            total: incomplete + completed,
            incomplete: incomplete,
            completed: completed,
            percent_completed: Math.round((completed / (completed + incomplete)) * 100)
        }        
    }

    getTopItems(data){
        let upcomingItems = [];
        let topPriorityItems = [];
        const items = Object.values(data)
        
        // Priority check
        Object.values(itemContext.PRIORITY).map(level => {
            const levelItems = items.filter(item => item['priority'] === level & item['status'] === itemContext.STATUS.INCOMPLETE )
            topPriorityItems.push(...levelItems)
        })

        // Upcoming check
        let scheduled = items.filter(item => item['start_date'] && isAfter(new Date(item['start_date']), new Date().setHours(0,0,0,0)) || item['end_date'] && isAfter(new Date(item['end_date']), new Date().setHours(0,0,0,0)) )
        scheduled = _.sortBy(scheduled, (item) => Math.min(item['start_date'] && new Date(item['start_date']), item['end_date'] && new Date(item['end_date'])))
        upcomingItems.push(...scheduled)

        // Remove duplicates
        let result = upcomingItems.concat(topPriorityItems)
        let filteredItems = []
        let itemIDs = []
        result.map(item => {
            if(!itemIDs.includes(item['itemID'])){
                filteredItems.push(item)
                itemIDs.push(item['itemID'])
            }
        })
        return filteredItems

    }
    
}

export default Page;